// eslint-disable-next-line no-unused-vars
import React, { CSSProperties, useEffect, useState } from "react";
import XDiv from "./XDiv";
import AtthExpress from "IZOX/ARCS/API/AtthExpress";
import _ from "lodash";
import { DOMAIN } from "__SYSDefault/Domain";

/**
 * @typedef {import("./XDiv").xdivparams} xdivparams
 * 
 * @typedef {Object} xvideoparams
 * @property {Number | String} width
 * @property {Number | String} height
 * @property {Object | String} source
 * @property {Boolean} noResize
 * @property {Boolean} controls
 * @property {Boolean} autoPlay
 * 
 * @param {ximageparams & xdivparams} param0
 * 
 */
function XVideo({
  width = "auto",
  height = "auto",
  noResize = false,
  source = "",
  controls = true,
  autoPlay = true,
  ...others
}){

  const [src, setSrc] = useState("");

  useEffect(() => {

    let timeout;

    async function fetch(){
      let _src = source;
      if(_.isArray(source) && source.length > 0){
        _src = source[0];
      }

      if(!_.isString(_src)){
        if(_src.refID){
          if(_src.refID.startsWith("izox::")){
            let res = await AtthExpress.GetBlobUrl(_src.refID);
            let {url} = res;
            if(!url?.startsWith("http")){
              url = `${DOMAIN}${url?.slice(1)}`;
            }
            timeout = setTimeout(() => setSrc(url), 0);
          }else{
            timeout = setTimeout(() => setSrc(_src.refID), 0);
          }
        }else{
          timeout = setTimeout(() => setSrc(_src), 0);
        }
      }else{
        if(_src?.startsWith("izox::")){
          let res = await AtthExpress.GetBlobUrl(_src);
          timeout = setTimeout(() => setSrc(res.url), 0);
        }else{
          timeout = setTimeout(() => setSrc(_src), 0);
        }
      }
    }
    fetch();
    return () => {
      if(timeout){
        clearTimeout(timeout);
      }
    };
  }, [source]);

  let _flexShrink = undefined;
  if(noResize) _flexShrink = 0;

  let imgStyle = {
    display: "block",
    width: "100%", 
    maxWidth: "100%",
    height: "100%", 
    maxHeight: "100%"
  };

  return (
    <XDiv 
      width={width}
      height={height}
      flexShrink={_flexShrink}
      overflow="hidden"
      {...others}>
      <video src={src} alt="" style={imgStyle} 
        controls={controls}
        autoPlay={autoPlay}/>
    </XDiv>
  );
}

export default XVideo;